import Vue from "vue"
import VueI18n from "vue-i18n"
import getLocale from "@/utils/locale"
import store from "@/store/"
import StoreBadgesController from "@/shared/store-badges/store-badges-controller"

Vue.use(VueI18n)

const init = () => {
  const nodes = document.querySelectorAll(".vue-store-badges")
  const locale = getLocale()
  nodes.forEach((el) => {
    new Vue({
      name: "StoreBadgesApp",
      el,
      store,
      i18n: new VueI18n({ locale }),
      render(h) {
        return h(StoreBadgesController, { props: { buttonCode: "body-20200123-store_badges" } })
      }
    })
  })
}

init()
